export default {
    text: 'Cricket',
    path: '/cricket',
    icon: 'cricket.svg',
    permissions: {
        XDATA: 'READ'
    },
    children: [
        {
            text: 'Tournament Groups',
            path: '/cricket/tournamentgroups',
            children: [],
            permissions: {
                XDATA: 'READ'
            }
        },
        {
            text: 'Tournaments',
            path: '/cricket/tournaments',
            children: [],
            permissions: {
                XDATA: 'READ'
            }
        },
        {
            text: 'Matches',
            path: '/cricket/matches',
            children: [],
            permissions: {
                XDATA: 'READ'
            }
        },
        {
            text: 'Teams',
            path: '/cricket/teams',
            children: [],
            permissions: {
                XDATA: 'READ'
            }
        },
        {
            text: 'ICC Team Rankings',
            path: '/cricket/iccteamrankings',
            children: [],
            permissions: {
                XTEAMRATINGS: 'READ'
            }
        },
        {
            text: 'Squads',
            path: '/cricket/squads',
            children: [],
            permissions: {
                XDATA: 'READ'
            }
        },
        {
            text: 'Players',
            path: '/cricket/players',
            children: [],
            permissions: {
                XDATA: 'READ'
            }
        },
        {
            text: 'Venues',
            path: '/cricket/venues',
            children: [],
            permissions: {
                XDATA: 'READ'
            }
        }
    ]
};
